import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function TransparencySection() {
  const { ref, visible } = useScrollAnimation();

  return (
    <section className="py-20 px-6" style={{ background: '#060D18' }}>
      <div
        ref={ref}
        className="max-w-2xl mx-auto"
        style={{
          opacity: visible ? 1 : 0,
          transform: visible ? 'translateY(0)' : 'translateY(24px)',
          transition: 'opacity 0.7s ease, transform 0.7s ease',
        }}
      >
        <div
          className="rounded-2xl px-8 py-8 border text-center"
          style={{ background: '#0F1E30', borderColor: 'rgba(245,165,32,0.2)' }}
        >
          <div
            className="w-10 h-10 flex items-center justify-center rounded-full mx-auto mb-5"
            style={{ background: 'rgba(245,165,32,0.1)' }}
          >
            <i className="ri-information-line text-lg" style={{ color: '#F5A520' }} />
          </div>
          <h4 className="text-lg font-semibold mb-4 text-white">
            Transparência e cuidado
          </h4>
          <p className="text-sm leading-relaxed mb-4" style={{ color: '#7A9BB5' }}>
            A sessão inicial gratuita da Equilibrada🧠Mente™ tem caráter psicoeducativo e de autorregulação emocional.
          </p>
          <p className="text-sm leading-relaxed mb-4" style={{ color: '#7A9BB5' }}>
            Ela foi criada para ajudar pessoas a compreender melhor o funcionamento do sistema nervoso e experimentar técnicas de desaceleração emocional.
          </p>
          <p className="text-sm leading-relaxed font-medium" style={{ color: '#5A7A95' }}>
            Essa experiência não substitui acompanhamento médico ou psicológico presencial.
          </p>
        </div>
      </div>
    </section>
  );
}